import { render, staticRenderFns } from "./ClientDataForm.vue?vue&type=template&id=1da97d12&"
import script from "./ClientDataForm.vue?vue&type=script&lang=js&"
export * from "./ClientDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports